import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const calendarHeaderFn = /* @__PURE__ */ createRecipe('calendar-header', {}, [])

const calendarHeaderVariantMap = {}

const calendarHeaderVariantKeys = Object.keys(calendarHeaderVariantMap)

export const calendarHeader = /* @__PURE__ */ Object.assign(memo(calendarHeaderFn.recipeFn), {
  __recipe__: true,
  __name__: 'calendarHeader',
  __getCompoundVariantCss__: calendarHeaderFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: calendarHeaderVariantKeys,
  variantMap: calendarHeaderVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, calendarHeaderVariantKeys)
  },
  getVariantProps: calendarHeaderFn.getVariantProps,
})